<div class="flex items-center justify-center dialog-header">
  {{ type }} Email Configuration
  <div class="absolute right-2">
    <button (click)="handleCloseDialog()" class="outline-none p-5">
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>

<div class="dialog-content">
  <form [formGroup]="emailCenterForm" (ngSubmit)="submitForm()" class="p-fluid grid grid-cols-2 gap-6">

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">Client Name *</label>
      <input pInputText formControlName="clientName"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="emailCenterForm.get('clientName')?.invalid && (emailCenterForm.get('clientName')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">Client name is required.</div>
    </div>


     <div class="flex flex-col">
      <label for="center_id" class="mb-2 font-semibold">Center ID *</label>
      <p-select id="center_id" formControlName="center_id"
                [options]="centers" optionLabel="center_name" optionValue="center_id"
                placeholder="Select a Center" class="w-full"></p-select>

        <div *ngIf="emailCenterForm.get('center_id')?.invalid && (emailCenterForm.get('center_id')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">Center ID is required.</div>
        
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">API Key *</label>
      <input pInputText formControlName="api_key"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="emailCenterForm.get('api_key')?.invalid && (emailCenterForm.get('api_key')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">API Key is required.</div>
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">Provider *</label>
      <input pInputText formControlName="provider"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="emailCenterForm.get('provider')?.invalid && (emailCenterForm.get('provider')?.touched || submitted)"
        class="text-red-500 text-xs mt-1">Provider is required.</div>
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">From Email *</label>
      <input pInputText formControlName="fromEmail"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">Reply To Email</label>
      <input pInputText formControlName="reply_to_email"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">Host *</label>
      <input pInputText formControlName="host"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">Port *</label>
      <input pInputText type="number" formControlName="port"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">User *</label>
      <input pInputText formControlName="user"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">Password *</label>
      <input pInputText type="password" formControlName="password"
        class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">Status *</label>
      <p-select [options]="statusOptions" formControlName="status" placeholder="Select status"
        class="w-full" />
    </div>

    <div class="col-span-2 flex justify-end mt-2">
      <p-button label="Submit" type="submit" [loading]="isLoading" icon="pi pi-check" class="w-full"
        [disabled]="emailCenterForm.invalid || isLoading"></p-button>
    </div>

  </form>
</div>
